module.exports = __webpack_public_path__ + "media/application/images/2023/04_still-1600x900-d255975231228a1b75714ee4dedb8244.png";